<template>
  <appCdialog
    ref="cDialog"
    v-bind="$attrs"
    top="10vh"
    title="添加应用"
    v-on="$listeners"
    width="490px"
  >
    <div class="add-application">
      <div class="add-app-top">
        <span class="app-top-input">
          <el-input placeholder="请输入应用名称" v-model="searchAppVal">
            <i
              slot="suffix"
              @click="searchApp"
              class="el-input__icon el-icon-search"
              style="cursor: pointer"
            ></i>
          </el-input>
        </span>
        <!-- <span class="app-top-btn">
          <el-button @click="resertSearch" type="text" icon="el-icon-plus">重置</el-button>
        </span> -->
      </div>
      <div class="add-app-content">
        <div class="table-list">
          <div class="table-list-item" v-for="item in appLists" :key="item.id">
            <span class="item-label">{{item.name}}</span>
            <span class="item-checkbox">
              <el-checkbox v-model="item.check"></el-checkbox>
            </span>
          </div>
        </div>
      </div>
      <div class="add-app-btn">
        <el-button @click="sureAdd" class="curr-36"> 确定 </el-button>
        <el-button @click="closeSchedule" class="cancle-36"> 取消 </el-button>
      </div>
    </div>
  </appCdialog>
</template>

<script>
import appCdialog from "@/components/sys/dialog/dialog.vue";
export default {
  components: { appCdialog },
  data() {
    return {
      appLists: [
        { id: 1, check: true, name: "教务系统" },
        { id: 2, check: false, name: "学工系统" },
        { id: 3, check: true, name: "教务系统" },
        { id: 4, check: false, name: "学工系统" },
      ],
      searchAppVal: ''
    };
  },
  methods: {
    /** 关闭 */
    closeSchedule() {
      this.$refs.cDialog.handleClose();
    },
    searchApp() {},
    resertSearch() {
      this.searchAppVal = ''
    },
    sureAdd() {
      console.log(this.appLists);
    }
  },
};
</script>

<style lang='less' scoped>
.add-application {
  height: 460px;
  padding: 0 20px;
  .add-app-top {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .app-top-input {
      height: 30px;
      width: 269px;
    }
    .app-top-btn {
      width: 40px;
      height: 30px;
    }
  }
  .add-app-content {
    height: calc(100% - 58px - 60px);
    .table-list-item {
      display: flex;
      padding-left: 36px;
      padding-right: 16px;
      justify-content: space-between;
      align-items: center;
      .item-label {
        width: 300px;
      }
      .item-checkbox {
        height: 20px;
        width: 15px;
      }
    }
  }
  .add-app-btn {
    height: 36px;
    line-height: 36px;
    text-align: right;
    margin-bottom: 22px;
  }
}
</style>